import datePickerView from './datePickerComponent.html';
import '../datePickerCommon.css';
import './datePickerComponent.css';
import moment from 'moment';
import _ from 'lodash';
import { zIndexManager } from 'components/sharpr/zIndex/manager/zIndexManager';

export function datePickerComponent() {
	return {
		bindings: {
			model: '=',
			format: '@?',
			align: '@?',
			placeholder: '@?',
			timePicker: '<?',
			isOpen: '=?',
		},
		controllerAs: 'vm',
		controller: datePickerComponentCtrl,
		template: datePickerView,
	};
}

export class datePickerComponentCtrl {
	constructor($element) {
		'ngInject';
		this.$element = $element;
	}

	$onInit() {
		this.input = this.$element.find('input')[0];
		if (this.model) {
			this.model = moment(this.model);
			if (!this.model.isValid()) {
				this.model = undefined;
			}
		}
		if (!this.format) {
			this.format = this.timePicker ? 'M/D/YYYY h:mma' : 'M/D/YYYY';
		}
		this.zIndexTop = zIndexManager.next();
		this._initAlignment();
	}

	_getModelMoment() {
		let model = moment(this.model || undefined);
		if (!model.isValid()) {
			model = moment();
		}
		return model;
	}

	_initCalendar() {
		this.month = this._getModelMoment().date(1);
		this.calendar = this.getWeeks(this.month);
	}

	_initTimes() {
		if (this.model) {
			const datetime = moment(this.model);
			if (datetime.isValid()) {
				this.time = {
					hour: datetime.format('h'),
					minute: datetime.format('mm'),
					ampm: datetime.format('A'),
				};
			}
		}
		if (!this.time) {
			this.time = {
				hour: '8',
				minute: '00',
				ampm: 'AM',
			};
		}
		let step = this.time.minute.match(/(0|5)$/) ? 5 : 1;
		this.hours = _.range(1, 13).map(String);
		this.minutes = _.range(0, 60, step).map(m => (m < 10 ? '0' : '') + m);
		this.ampm = ['AM', 'PM'];
	}

	_initAlignment() {
		const h = (this.align || '').match(/(left|center|right)/i);
		const v = (this.align || '').match(/(top|bottom)/i);
		this.hAlign = h ? h[1].toLowerCase() : 'left';
		this.vAlign = v ? v[1].toLowerCase() : 'bottom';
	}

	handleTabKey(evt) {
		if (evt.code == 'Tab' || evt.keyCode == 9) {
			this.handleFocusAndBlur('blur');
		}
	}

	handleInputFocus() {
		if (!this.isOpen) {
			this.handleFocusAndBlur('focus');
		}
	}

	handleFocusAndBlur(focusOrBlur) {
		if (focusOrBlur == 'focus') {
			this.isOpen = true;
			this.zIndexTop = zIndexManager.next();
			this._initCalendar();
			if (this.timePicker) {
				this._initTimes();
			}
		} else if (this.isOpen) {
			this.setIfValid();
			this.isOpen = false;
		}
	}

	updateMonth(direction) {
		this.month.add(direction, 'months');
		this.calendar = this.getWeeks(this.month);
	}

	setDate(day) {
		this.model = day.date;
		// clear out all selected dates
		this.calendar.forEach(days => {
			days.forEach(day => (day.classes[3] = ''));
		});
		day.classes[3] = 'start-of-range end-of-range';
		if (this.timePicker) {
			this.setTime();
		} else {
			this.isOpen = false;
		}
	}

	setTime() {
		this.model = this._getModelMoment();
		let hour = Number(this.time.hour);
		let minute = Number(this.time.minute);
		if (this.time.ampm == 'PM' && hour < 12) {
			hour += 12;
		} else if (this.time.ampm == 'AM' && hour == 12) {
			hour = 0;
		}
		this.model.hours(hour);
		this.model.minutes(minute);
		this.input.value = this.model.format(this.format);
	}

	setIfValid() {
		const date = moment(this.input.value);
		if (date.isValid()) {
			// set model value
			this.model = date;
			this.input.value = date.format(this.format);
		} else {
			// revert input value to model value
			// TODO: inform the user of the invalid date
			this.input.value = moment(this.model).format(this.format);
		}
	}

	getWeeks(forMonth) {
		let selectedDate = this.model ? moment(this.model) : false;
		let selectedYmd = selectedDate && selectedDate.isValid() ? selectedDate.format('YYYYMMDD') : false;
		let todayYmd = moment().format('YYYYMMDD');
		let monthNumber = forMonth.format('M');
		let firstDay = forMonth.clone().startOf('month').startOf('week');
		let lastDay = forMonth.clone().endOf('month').endOf('week');
		let weeks = [];
		let days = [];
		let currDay = firstDay.clone();

		let count = 0;
		while (currDay <= lastDay) {
			let ymd = currDay.format('YYYYMMDD');
			days.push({
				date: currDay.clone(),
				number: currDay.format('D'),
				ymd: ymd,
				classes: [
					'day-num',
					[0, 6].indexOf(count % 7) > -1 ? 'weekend' : 'weekday',
					monthNumber == currDay.format('M') ? '' : 'context',
					selectedYmd == ymd ? 'start-of-range end-of-range' : '',
					todayYmd == ymd ? 'today' : '',
				],
			});
			currDay.add(1, 'day');
			if (count % 7 == 6) {
				// restart week after saturday
				weeks.push(days);
				days = [];
			}
			count++;
		}
		forMonth.weeks = weeks;
		return weeks;
	}
}
